import Injection = EECore.Injection;
import Model from "../models/promotion/promotionModel";
import PromotionService from "../../services/promotion/promotionService";

@Injection.injectableClass("PersonalizedAccessCodePromotion")
export default class PersonalizedAccessCode implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("PersonalizedAccessCodePromotion", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("PersonalizedAccessCodePromotion", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  @Injection.injectableProperty("PersonalizedAccessCodePromotion", "PromotionService")
  private promotionService: PromotionService;

  constructor(templateFactory: EECore.UI.TemplateFactory, htmlHelper: EECore.HtmlHelper, promotionService: PromotionService) {
    this.templateFactory = templateFactory;
    this.htmlHelper = htmlHelper;
    this.promotionService = promotionService;
  }

  load() {

    return new EECore.Promise<Element, string>((resolve, reject) => {
      const contentRequest = this.promotionService.getPersonalizedAccessCodeContent();
      contentRequest.then((content) => {
        const promotionElement = this.render(content);
        resolve(promotionElement);
        this.bindEvents(promotionElement);
        this.scheduleDisplay(promotionElement);
      }).catch(() => {
        reject("Could not get the promotion information");
      });
    });
  }

  private render(content: string): Element {
    const model: Model = { content: content };
    const template = this.templateFactory.getTemplate("PersonalizedAccessCode", model);

    return template;
  }

  private bindEvents(content: Element) {
    const closeButton = content.querySelector(".close-button");
    closeButton.addEventListener("click", () => {
      this.promotionService.updateReminder("PERSONALIZED_ACCESS_CODE").then(() => {
        this.htmlHelper.removeCssClass(content, "active");
      });
    });
  }

  private scheduleDisplay(content: Element) {
    setTimeout(() => {
      this.htmlHelper.addCssClass(content, "active");
    }, 500);
  }
}